import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultiIconComponent } from './multi-icon/multi-icon.component';

@NgModule({
  exports: [MultiIconComponent],
  imports: [CommonModule, MultiIconComponent],
})
export class MultiIconModule {}
